'use client';

import * as React from 'react';
import { DayPicker } from 'react-day-picker';
import { ChevronLeftIcon } from '../../icons/ChevronLeft';
import { ChevronRightIcon } from '../../icons/ChevronRight';
import { cn } from '../../utils/tailwind';
export type CalendarProps = React.ComponentProps<typeof DayPicker>;
function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return <DayPicker showOutsideDays={showOutsideDays} className={cn('p-3 bg-white', className)} classNames={{
    months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
    month: 'space-y-4',
    caption: 'flex justify-center pt-1 relative items-center',
    caption_label: 'text-sm font-medium',
    nav: 'space-x-1 flex items-center',
    nav_button: cn(
    // buttonVariants({ variant: 'outline' }),
    'h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100'),
    nav_button_previous: 'absolute left-1',
    nav_button_next: 'absolute right-1',
    table: 'w-full border-collapse space-y-1',
    head_row: 'flex',
    head_cell: 'text-muted-foreground rounded-[6px] w-8 font-normal text-[0.8rem]',
    row: 'flex w-full mt-2',
    cell: 'text-center text-sm p-0 relative [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-[6px] last:[&:has([aria-selected])]:rounded-r-[6px] focus-within:relative focus-within:z-20',
    day: cn(
    // buttonVariants({ variant: 'ghost' }),
    'h-8 w-8 p-0 font-normal aria-selected:opacity-100 hover:bg-gray-50'),
    day_selected: 'bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground',
    day_today: 'bg-accent text-accent-foreground',
    day_outside: 'text-muted-foreground opacity-50',
    day_disabled: 'text-muted-foreground opacity-50',
    day_range_middle: 'aria-selected:bg-primaryBg aria-selected:text-accent-foreground',
    day_hidden: 'invisible',
    ...classNames
  }} components={{
    IconLeft: () => <ChevronLeftIcon width={32} height={32} />,
    IconRight: () => <ChevronRightIcon width={32} height={32} />
  }} {...props} data-sentry-element="DayPicker" data-sentry-component="Calendar" data-sentry-source-file="Calendar.tsx" />;
}
Calendar.displayName = 'Calendar';
export { Calendar };